import { render, staticRenderFns } from "./SplashFeatures.vue?vue&type=template&id=cee21224&scoped=true&"
import script from "./SplashFeatures.vue?vue&type=script&lang=js&"
export * from "./SplashFeatures.vue?vue&type=script&lang=js&"
import style0 from "./SplashFeatures.vue?vue&type=style&index=0&id=cee21224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee21224",
  null
  
)

export default component.exports